import { EventType } from "./constants/event-type-constants";
import { SwimmerConstants } from "./constants/swimmer-constants";
import { MarketingClientAttributesConstants } from "./constants/marketing-client-attributes-constants";
import { MarketingClientConstants } from "./constants/marketing-client-constants";
import { DOMHelper } from "./helpers/dom-helper";
import { Utils } from "./utils/utils";
import { Capping } from "./marketing-client-capping";
import { Utilization } from "./marketing-client-utilization";
import { httpInstance } from "./http/http";
import { TimerCountdown } from "./helpers/timer-countdown";
import { NewsSwimmerConstants } from "./constants/news-swimmer-constants"; 

export class Swimmer {
    hiding = false;
    rwSwimmerID = "rw-swimmer";
    copSwimmerID = "content-onexit-popup-swimmer";
    swimmerRW: Element | null;
    swimmerCOP: Element | null;
    copButtonCollaps: Element | null;
    copButtonArrowUp: Element | null;
    copButtonArrowLeft: Element | null;
    copButtonArrowRight: Element | null;
    copArticleBoxes: Array<Element>;
    swimmerPromoBox: HTMLElement | null;
    swimmerPromoBoxButton: HTMLElement | null;
    padlockElement: HTMLElement | null;
    copInterval: ReturnType<typeof setInterval>;
    currentBoxToDisplay = 0;
    utilizationObject: Utilization = new Utilization(httpInstance);
    timerCountdown: TimerCountdown;

    classSwimmerPromoBoxButton = ".nw_2021_swimmer-button-wrapper";
    classPadlockElement = ".nw_2021_padlock"

    newsSwimmer: Element | null;
    newsButtonClose: Element | null;
    newsSwimmerWrapper: Element | null;
    newsSwimmerCollapsed: Element | null;
    newsSwimmerArrowSvg: Element | null;
    newsSwimmerStep2Close: Element | null;

    constructor(public isMobile: boolean, public capping: Capping) { }

    init() {
        const swimmerPlaceholders: Array<Element> = DOMHelper.querySelectorAsArray(SwimmerConstants.swimmerSelector),
            placecholderHP: Element | undefined = swimmerPlaceholders.find(swimmerPlaceholder => this.placecholderIsSwimmerHP(swimmerPlaceholder)),
            swimmerHPIsNotEmpty: boolean = !!placecholderHP && !!DOMHelper.querySelector("section", placecholderHP)?.innerHTML.length,
            ddboxIsVisible: boolean = this.ddboxIsVisible();

            this.initializePadlock();
            this.initializeSwimmerPromoBox();

            const fullContentVisibleForUser = window["wyborcza_pl"]?.MarketingClient?.userData?.profile?.fullContentVisibleForUser
            const linkToPadlock =  this.swimmerPromoBox?.dataset?.linkPadlock;
            const isSwimmerVisible: boolean = !(linkToPadlock === "true" && (fullContentVisibleForUser === true || fullContentVisibleForUser === undefined));

        swimmerPlaceholders.forEach(swimmerPlaceholder => {
            const swimmer: Element | null = DOMHelper.querySelector("section", swimmerPlaceholder) as Element,
                isSwimmerHp: boolean = !!placecholderHP && this.placecholderIsSwimmerHP(swimmerPlaceholder),
                isSwimmerShouldBeVisible: boolean = swimmerHPIsNotEmpty ? isSwimmerHp : !ddboxIsVisible;

            if (isSwimmerShouldBeVisible && !!swimmer && isSwimmerVisible) {
                this.sendCapping(swimmer);
                this.prepareSwimmer(swimmer, isSwimmerHp);
            } else {
                swimmer?.classList.remove(SwimmerConstants.visibleClass);
                Utils.hideContainer(swimmer as HTMLElement, MarketingClientConstants.dHiddenClassName);
            }
        })
        this.initializeNewsSwimmer();

        if (!ddboxIsVisible) {
            const swimmer = DOMHelper.querySelector(SwimmerConstants.timerDateSelector) as HTMLElement;
            
            if(linkToPadlock === "true"){
                this.bindEventsHideSwimmerAtHeightOfPadlock();
                this.bindEventsSwimmerPromoBoxScrollToPadlock();
            }
            this.initializeTimer(swimmer?.dataset?.timerSwimmer as string);
        }
    }

    initializeNewsSwimmer(): void{
        this.initializeNewsSwimmerElements();
        this.bindNewsSwimmerEvents();
    }

    initializeNewsSwimmerElements(){
        this.newsSwimmer = DOMHelper.querySelector(NewsSwimmerConstants.newsSwimmerClass);
        this.newsButtonClose = DOMHelper.querySelector(NewsSwimmerConstants.newsButtonCloseClass);
        this.newsSwimmerWrapper = DOMHelper.querySelector(NewsSwimmerConstants.newsSwimmerWrapperClass);
        this.newsSwimmerCollapsed = DOMHelper.querySelector(NewsSwimmerConstants.newsSwimmerCollapsedClass);
        this.newsSwimmerArrowSvg = DOMHelper.querySelector(NewsSwimmerConstants.newsSwimmerArrowSvg);
        this.newsSwimmerStep2Close = DOMHelper.querySelector(NewsSwimmerConstants.newsSwimmerStep2Close);
    }

    bindNewsSwimmerEvents(){
        this.bindNewsSwimmerStep2CloseEvent();
        this.bindNewsButtonCloseEvent();
        this.bindNewsSwimmerArrowSvgEvent();
    }
    
    bindNewsSwimmerStep2CloseEvent(): void {
        if (this.newsSwimmerStep2Close) {
            this.newsSwimmerStep2Close.addEventListener(EventType.CLICK, (event) => {
                this.newsSwimmer?.classList.remove(SwimmerConstants.visibleClass)
            })
        }
    }
    
    bindNewsButtonCloseEvent(): void {
        if (this.newsButtonClose) {
            this.newsButtonClose.addEventListener(EventType.CLICK, (event) => {
                event.preventDefault();
                this.newsSwimmerWrapper?.classList.add(SwimmerConstants.hiddenClass)
                this.newsSwimmer?.classList.add(SwimmerConstants.visibleClass)
                this.newsSwimmerCollapsed?.classList.remove(SwimmerConstants.hiddenClass)
            })
        }
    }
    
    bindNewsSwimmerArrowSvgEvent(): void {
        if (this.newsSwimmerArrowSvg) {
            this.newsSwimmerArrowSvg.addEventListener(EventType.CLICK, (event) => {
                this.newsSwimmerWrapper?.classList.remove(SwimmerConstants.hiddenClass)
                this.newsSwimmerCollapsed?.classList.add(SwimmerConstants.hiddenClass)
            })
        }
    }

    initializeSwimmerPromoBox(): void {
        this.swimmerPromoBox = DOMHelper.querySelector(SwimmerConstants.timerDateSelector) as HTMLElement;
        this.swimmerPromoBoxButton = DOMHelper.querySelector(this.classSwimmerPromoBoxButton, this.swimmerPromoBox) as HTMLElement;
    }

    initializePadlock(): void {
        this.padlockElement = DOMHelper.querySelector(this.classPadlockElement) as HTMLElement;
    }

    bindEventsSwimmerPromoBoxScrollToPadlock(): void {
        if (this.swimmerPromoBoxButton) {
            this.swimmerPromoBoxButton.addEventListener(EventType.CLICK, (event) => {
                event.preventDefault();
                this.scrollToPadlockForSwimmerPromoBox();
            })
        }
    }

    bindEventsHideSwimmerAtHeightOfPadlock(): void {
        if (this.swimmerPromoBox) {
            document.addEventListener(EventType.SCROLL, () => {
                this.toggleSwimmer();
            })
        }
    }

    toggleSwimmer(): void {
        const swimmerTop: number | undefined = this.swimmerPromoBox?.offsetTop,
            sectionTop: number | undefined = this.padlockElement?.getBoundingClientRect().top,
            swimmerHeight: number = this.swimmerPromoBox?.getBoundingClientRect().height || 250,
            height: number = this.getScreenHeight();

        if (sectionTop && swimmerTop && sectionTop <= swimmerTop) {
            this.closeSwimmerPromoBox();

        } else if (sectionTop && (window.scrollY + (height - swimmerHeight) + 20) < sectionTop) {
            this.showSwimmerPromoBox();
        }
    }
    
    getScreenHeight(): number {
        return window.innerHeight
            || document.documentElement.clientHeight
            || document.body.clientHeight;
    }
    
    scrollToPadlockForSwimmerPromoBox(): void {
        if (this.padlockElement) {
          requestAnimationFrame(() => {
            setTimeout(() => {
              this.scrollToElement();
              this.closeSwimmerPromoBox();
            }, 100);
          });
        }
    }
      
    scrollToElement() {
        if (this.padlockElement) {
            const top = this.padlockElement.offsetTop - window.innerHeight / 3;   
            Utils.smoothScrollTo(top);
        }
    }

    closeSwimmerPromoBox(): void {
        this.swimmerPromoBox?.classList.remove(SwimmerConstants.visibleClass);
    }

    showSwimmerPromoBox(): void {
        if (!this.swimmerPromoBox?.classList.contains(SwimmerConstants.closedManuallyClass)) { 
            this.swimmerPromoBox?.classList.add(SwimmerConstants.visibleClass);
        }
    }
    
    sendCapping(swimmer: Element, onDisplay = false) {
        this.capping.sendCappingEvent(swimmer, onDisplay);
    }

    ddboxIsVisible(): boolean {
        const mainObjectKey = "wyborcza_pl",
            mainObject = window[mainObjectKey];

        return mainObject &&
            mainObject.MarketingClient &&
            mainObject.MarketingClient.bannersObject &&
            mainObject.MarketingClient.bannersObject.ddbox &&
            mainObject.MarketingClient.bannersObject.ddbox.ddboxIsVisible;
    }

    placecholderIsSwimmerHP(swimmer: Element): boolean {
        return swimmer.getAttribute(MarketingClientAttributesConstants.placeholderId) === SwimmerConstants.swimmerHPSelector;
    }

    prepareSwimmer(swimmer: Element, isSwimmerHP: boolean) {
        const padlock: Element | null = document.querySelector(SwimmerConstants.padlockSelector),
            isOnExitPopUp: boolean = !!swimmer.getAttribute(SwimmerConstants.dataOnExitPopUp) && this.isMobile,
            isUserInactivityTimeout: boolean = !!swimmer.getAttribute(SwimmerConstants.dataUserInactivityTimeout) && this.isMobile,
            isPromoboxDelay: boolean = !!swimmer.getAttribute(SwimmerConstants.dataPromoboxDelay);

        this.swimmerRW = DOMHelper.getElementById(this.rwSwimmerID);
        this.swimmerCOP = DOMHelper.getElementById(this.copSwimmerID);

        if (this.swimmerCOP) {
            this.initializeCopSwimmerButtons();
            this.initializeCopSwimmerBoxes();
        }

        this.bindActions(swimmer);

        if (padlock) {
            this.bindAutoClosing(swimmer);
        }

        if (isSwimmerHP) {
            this.bindAutoClosingForSwimmerHP(swimmer);
        } else if (isOnExitPopUp) {
            this.onExitPopUp(swimmer);
        } else if (isPromoboxDelay) {
            this.bindVisibilityForPromoboxDelay(swimmer);
        } else if (isUserInactivityTimeout) {
            this.onUserInactivityTimeout(swimmer);
        } else if (!this.swimmerRW) {
            this.sendCapping(swimmer, true);
        }
    }

    initializeCopSwimmerButtons() {
        this.copButtonCollaps = DOMHelper.getElementById(SwimmerConstants.collapsButtonID);
        this.copButtonArrowUp = DOMHelper.getElementById(SwimmerConstants.arrowUpID);
        this.copButtonArrowLeft = DOMHelper.getElementById(SwimmerConstants.arrowLeftID);
        this.copButtonArrowRight = DOMHelper.getElementById(SwimmerConstants.arrowRightID);
    }

    initializeCopSwimmerBoxes() {
        this.copArticleBoxes = [];
        for (let boxID of SwimmerConstants.articleBoxesID) {
            const box = DOMHelper.getElementById(boxID);
            if (box) this.copArticleBoxes.push(box);
        }
    }

    initializeTimer(dateEnd: string) {
        if (!dateEnd) return;

        this.timerCountdown = new TimerCountdown(dateEnd, SwimmerConstants.timerSelector);
        this.timerCountdown?.init();
    }

    bindActions(swimmer: Element) {
        const closeButton: Element | null = swimmer.querySelector(SwimmerConstants.closeButtonSelector);

        if (closeButton) {
            closeButton.addEventListener(EventType.CLICK, (event) => {
                event.preventDefault();
                this.closeSwimmerManually(swimmer);
            })
        }

        if (this.swimmerCOP) this.bindCopSwimmerEvents(swimmer);
    }

    bindCopSwimmerEvents(swimmer: Element) {
        this.bindCopCollaps();
        this.bindCopArrowUp();
        this.bindCopArrowLeft();
        this.bindCopArrowRight();
        this.bindCopAutoRotation(swimmer);
    }

    bindCopCollaps() {
        if (this.copButtonCollaps) {
            this.copButtonCollaps.addEventListener(EventType.CLICK, (event) => {
                event.preventDefault();
                this.toggleCarousel();
            })
        }
    }

    bindCopArrowUp() {
        if (this.copButtonArrowUp) {
            this.copButtonArrowUp.addEventListener(EventType.CLICK, (event) => {
                event.preventDefault();
                this.toggleCarousel();
            })
        }
    }

    bindCopArrowLeft() {
        if (this.copButtonArrowLeft) {
            this.copButtonArrowLeft.addEventListener(EventType.CLICK, (event) => {
                event.preventDefault();
                clearInterval(this.copInterval);
                this.previousBox();
            })
        }
    }

    bindCopArrowRight() {
        if (this.copButtonArrowRight) {
            this.copButtonArrowRight.addEventListener(EventType.CLICK, (event) => {
                event.preventDefault();
                clearInterval(this.copInterval);
                this.nextBox();
            })
        }
    }

    bindCopAutoRotation(swimmer: Element) {
        const autoRotate = swimmer.getAttribute(SwimmerConstants.dataAutoRotation),
            rotationInterval = swimmer.getAttribute(SwimmerConstants.dataRotationInterval),
            intervalInMiliseconds = (rotationInterval && +rotationInterval > 0) ? (+rotationInterval * 1000) : 4000;

        if (autoRotate === 'true') {
            this.copInterval = setInterval(() => {
                this.nextBox();
            }, intervalInMiliseconds)
        }
    }

    closeSwimmerManually(swimmer: Element) {
        swimmer.classList.remove(SwimmerConstants.visibleClass);
        swimmer.classList.add(SwimmerConstants.closedManuallyClass);
    }

    bindAutoClosing(swimmer: Element) {
        window.addEventListener(EventType.CLICK, () => {
            if (!swimmer.classList.contains(SwimmerConstants.closedManuallyClass)) {
                this.checkSwimmerAutoVisibility(swimmer);
            }
        })
    }

    checkSwimmerAutoVisibility(swimmer: Element) {
        const padlockTop: number | undefined = document.querySelector(SwimmerConstants.padlockSelector)?.getBoundingClientRect().top,
            swimmerTop: number = swimmer.getBoundingClientRect().top,
            windowHeight = window.innerHeight;

        if (padlockTop && padlockTop <= swimmerTop) {
            swimmer.classList.remove(SwimmerConstants.visibleClass);
        }

        if (padlockTop && padlockTop > windowHeight) {
            swimmer.classList.add(SwimmerConstants.visibleClass);
        }
    }

    onExitPopUp(swimmer: Element) {
        const attribute: string | null = swimmer.getAttribute(SwimmerConstants.dataOnExitPopUpValue),
            minWindowScroll: number | undefined = Utils.attributeToNumber(attribute);

        this.bindAutoClosingForExitPopUp(swimmer, minWindowScroll);
    }

    onUserInactivityTimeout(swimmer: Element) {
        const attribute: string | null = swimmer.getAttribute(SwimmerConstants.dataUserInactivityTimeoutValue),
            timeout: number | undefined = Utils.attributeToNumber(attribute),
            showDdboxAndSendCapping = () => {
                swimmer.classList.add(SwimmerConstants.visibleClass);
                this.sendCapping(swimmer, true);
            };

        swimmer.classList.remove(SwimmerConstants.visibleClass);
        Utils.showElementAfterTimeout(showDdboxAndSendCapping, timeout);
    }

    bindVisibilityForPromoboxDelay(swimmer: Element) {
        const showAndSendCapping = () => {
            swimmer.classList.add(SwimmerConstants.visibleClass);;
            this.sendCapping(swimmer, true);
        },
            attribute: string | null = swimmer.getAttribute(SwimmerConstants.dataPromoboxDelayValue),
            attributeDelay: number | undefined = Utils.attributeToNumber(attribute),
            delay = attributeDelay && attributeDelay > 0 ? attributeDelay * 1000 : SwimmerConstants.promoboxDelay;

        swimmer.classList.remove(SwimmerConstants.visibleClass);

        setTimeout(() => {
            showAndSendCapping();
        }, delay);
    }

    bindAutoClosingForExitPopUp(swimmer: Element, minWindowScrollY: number = 800) {
        const screenHeight = window.innerHeight,
            minHeightForChangeVisibility = (screenHeight / 3);

        let lastScroll = 0,
            windowScrollY = 0,
            hasBeenChangedVisibility = false,
            canChangeVisibility = false,
            swimmerIsVisible = false;

        minWindowScrollY = minWindowScrollY - minHeightForChangeVisibility;

        if (minWindowScrollY < 1) {
            minWindowScrollY = 1;
        }

        swimmer.classList.remove(SwimmerConstants.visibleClass);

        window.addEventListener(EventType.SCROLL, () => {
            if (window.scrollY > minWindowScrollY) {
                if (window.scrollY > windowScrollY) {
                    swimmerIsVisible = false;
                    lastScroll = window.scrollY;
                }
                else {
                    swimmerIsVisible = true;
                }

                windowScrollY = window.scrollY;
            }
            else {
                swimmerIsVisible = false;
            }

            canChangeVisibility = Math.abs(lastScroll - window.scrollY) > minHeightForChangeVisibility;

            if (swimmerIsVisible && canChangeVisibility && !swimmer.classList.contains(SwimmerConstants.visibleClass) && !hasBeenChangedVisibility) {
                swimmer.classList.add(SwimmerConstants.visibleClass);
                this.sendCapping(swimmer, true);
                hasBeenChangedVisibility = true;
            }
        })
    }

    bindAutoClosingForSwimmerHP(swimmer: Element, minWindowScrollY: number = 800) {
        let windowScrollY = 0,
            swimmerHPisVisible = false,
            canChangeVisibility = false,
            lastScroll = 0,
            cappingIsSend = false;

        swimmer.classList.remove(SwimmerConstants.visibleClass);

        window.addEventListener(EventType.SCROLL, () => {
            if (window.scrollY > minWindowScrollY) {
                if (window.scrollY > windowScrollY) {
                    swimmerHPisVisible = false;
                }
                else {
                    swimmerHPisVisible = true;
                }

                windowScrollY = window.scrollY;
            }
            else {
                swimmerHPisVisible = false;
            }

            canChangeVisibility = !this.hiding && Math.abs(lastScroll - window.scrollY) > 40;

            if (swimmerHPisVisible) {
                if (canChangeVisibility && !swimmer.classList.contains(SwimmerConstants.visibleClass)) {
                    this.hiding = true;
                    lastScroll = window.scrollY;
                    swimmer.classList.add(SwimmerConstants.visibleClass);
                    swimmer.classList.remove(SwimmerConstants.animationClass);

                    if (!cappingIsSend) {
                        cappingIsSend = true;
                        this.sendCapping(swimmer, true);
                    }

                    setTimeout(() => {
                        this.hiding = false;
                    }, 1000);
                }
            }
            else {
                if (canChangeVisibility && swimmer.classList.contains(SwimmerConstants.visibleClass)) {
                    this.hiding = true;
                    lastScroll = window.scrollY;
                    swimmer.classList.add(SwimmerConstants.animationClass);

                    setTimeout(() => {
                        swimmer.classList.remove(SwimmerConstants.visibleClass);
                        this.hiding = false;
                    }, 1000);
                }
            }
        })
    }

    toggleCarousel() {
        const copSwimmerCarousel = DOMHelper.querySelector(SwimmerConstants.copSwimmerCarouselSelector);

        copSwimmerCarousel?.classList.toggle(SwimmerConstants.hiddenClass);
        this.copButtonCollaps?.classList.toggle(SwimmerConstants.hiddenClass);
        this.copButtonArrowUp?.classList.toggle(SwimmerConstants.hiddenClass);
    }

    nextBox() {
        this.copArticleBoxes[this.currentBoxToDisplay].classList.toggle(SwimmerConstants.hiddenClass);
        if (this.currentBoxToDisplay === this.copArticleBoxes.length - 1) {
            this.copArticleBoxes[0].classList.toggle(SwimmerConstants.hiddenClass);
            this.currentBoxToDisplay = 0;
        } else {
            this.copArticleBoxes[this.currentBoxToDisplay + 1].classList.toggle(SwimmerConstants.hiddenClass);
            this.currentBoxToDisplay += 1;
        }
    }

    previousBox() {
        this.copArticleBoxes[this.currentBoxToDisplay].classList.toggle(SwimmerConstants.hiddenClass);
        if (this.currentBoxToDisplay === 0) {
            this.copArticleBoxes[2].classList.toggle(SwimmerConstants.hiddenClass);
            this.currentBoxToDisplay = 2;
        } else {
            this.copArticleBoxes[this.currentBoxToDisplay - 1].classList.toggle(SwimmerConstants.hiddenClass);
            this.currentBoxToDisplay -= 1;
        }
    }
}
